import React from 'react';
import classes from './SkeletonArticles.module.scss';
import Skeleton from '../Skeleton';
import SkeletonArticlesCard from '../SkeletonArticlesCard/SkeletonArticlesCard';
import { GeneralContext } from '../../../context/generalContext';

export default function SkeletonArticles() {
  const { windowWidth } = React.useContext(GeneralContext);

  const items = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const [paginationItems, setPaginationItems] = React.useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
  const paginationItemsMob = [1, 2, 3, 4];

  React.useEffect(() => {
    if (windowWidth > 818) {
      setPaginationItems([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    } else if (windowWidth > 630 && windowWidth <= 818) {
      setPaginationItems([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    } else if (windowWidth > 430 && windowWidth <= 630) {
      setPaginationItems([1, 2, 3, 4, 5, 6]);
    } else {
      setPaginationItems([1, 2, 3, 4, 5]);
    }
  }, [windowWidth]);

  return (
    <div className='wrapper'>
      <div className={classes.header}>
        <Skeleton borderRadius='5px' width={180} height={25} isLight={false} />
      </div>

      <div className={classes.articles}>
        {items.map((_, index) => (
          <SkeletonArticlesCard key={index} />
        ))}
      </div>

      <div className={classes.moreBtn}>
        <Skeleton borderRadius='0' width='100%' height='100%' isLight />
        <div className={classes.moreBtnText}>
          <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
        </div>
      </div>
      <div className={classes.paginationDiv}>
        <div className={classes.pagination}>
          {paginationItems.map((_, index) => (
            <div className={classes.paginationItem} key={index}>
              <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
            </div>
          ))}
        </div>
        <div className={classes.pagination}>
          {windowWidth <= 430 && (
            <>
              {paginationItemsMob.map((_, index) => (
                <div className={classes.paginationItem} key={index}>
                  <Skeleton borderRadius='5px' width='100%' height='100%' isLight={false} />
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
